import React from 'react';
import PageTitle from '../../components/PageTitle';
import Spacer from '../../components/Spacer';
import ImageHero from '../../components/collect/ImageHero';
import SfeerbeeldSectie from '../../components/collect/SfeerbeeldSectie';
import KorteTekstSectie from '../../components/collect/KorteTekstSectie';
import CTAComponent from '../../components/collect/CTAComponent';
import TextBanner from '../../components/home/TextBanner';
import KleurenOpties from '../../components/collect/KleurenOpties';

import CardGallerij from '../../components/collect/CardGallerij';

import FullWidthImage from '../../components/collect/FullWidthImage'
import { Helmet } from 'react-helmet-async';

const Beat40 = () => {
  const sfeerbeelden = [
    { src: '/assets/img/main/beat40/1.jfif', alt: 'Beat40 1' },
    { src: '/assets/img/main/beat40/20230125-4DrawerBetonbasinNewMirror-DPS-Topview-16.webp', alt: 'Beat40 2' },
    { src: '/assets/img/main/beat40/nuance_edge.webp', alt: 'Beat40 3' },
  ];

  const korteTeksten = [
    "Er zijn wastafels in de materialen keramiek, beton en mineraalmarmer. Opbouwkommen zijn er in diverse materialen en kleuren. Maak het ondiepe badkamermeubel compleet met een fraaie spiegel of praktische spiegelkast.",
  ];

  const colors = [
    'Brandy', 'Carbon_Wood', 'Chestnut_Grey', 'Coal_Oak', 'Congo_Brown',
    'Forest_Green', 'Wit_Glans', 'Hudson_Oak', 'Keltic_Tan', 'Living_Oak',
    'Mat_Wit', 'Mojave', 'Mokka', 'Muddy', 'Natural_Oak', 'Navarro_Eiken',
    'Nebraska_Eiken', 'Nero', 'Oak_Grain', 'Prime_Oak', 'Ribbed_Navarro',
    'Ribbed_Nero', 'Rusty', 'Sand', 'Sequoia', 'Sherwood', 'Tweed_Beige',
    'Tweed_Moss', 'Urban_Oak', 'Walnut', 'Zambia_Black'
  ];
  
  
  return (
    <div className="beat40-page">

        <Helmet>
        <title>Thebalux | Beat 40</title>
        <meta name="description" content="De nieuwste badkamermeubelcollectie van Thebalux biedt stijlvolle en praktische badkamermeubelen. Vind jouw perfecte badkamerinrichting bij ons." />
        <meta name="keywords" content="badkamercollectie, badkamermeubelen, Thebalux, nieuwe collectie, badkamer inrichting, badkamerstijlen" />
        <link rel="canonical" href="https://www.thebalux.nl/collecties" />
        </Helmet>

      <ImageHero 
        title="Beat 40" 
        subtitle=""
        paddingTop='63px'
        imageSrc="/assets/img/main/beat40/1.jfif" 
      />

      <TextBanner 
        heading="Beat 40 is een programma badmeubels met slechts een diepte van 40cm." 
        paragraph="Ook hier kunt u kiezen uit vele soorten onderkasten in alle kleuren die Thebalux te bieden heeft. Combineer de serie met een mooie ondiepe wastafel of ga voor een fraaie set met opbouwkommen." 
      />

      <Spacer height='15vh'/>

      <SfeerbeeldSectie images={sfeerbeelden} />

      <Spacer height='8vh'/>

      <KorteTekstSectie teksten={korteTeksten} />

      <Spacer height='8vh'/>

      <FullWidthImage     
        imageSrc="/assets/img/main/beat40/nuance_edge.webp"
        title="Beat 40 "
        description="Er zijn wastafel in de materialen keramiek, beton en mineraalmarmer. Opbouwkommen zijn er in diverse materialen en kleuren. Maak het ondiepe badkamermeubel compleet met een fraaie spiegel of praktische spiegelkast."
      />

      <Spacer height='10vh'/>

      <KleurenOpties colors={colors} productName="Beat 40" />

      <Spacer height='8vh'/>

      <Spacer height='8vh'/>

      <Spacer height='15vh'/>
      
      <Spacer height='8vh'/>

    </div>
  );
};

export default Beat40;
